import { Component, OnInit,ViewChild } from '@angular/core';
import { SearchProductparam } from 'src/app/Models/search-product';
import { TransactionService } from 'src/app/Services/transaction.service';

@Component({
  selector: 'app-upload-csa-rate',
  templateUrl: './upload-csa-rate.component.html',
  styleUrls: ['./upload-csa-rate.component.css']
})
export class UploadCsaRateComponent implements OnInit {
  @ViewChild('file') myfileVariable:any;
  selectedPPFileName:string;
  showSpinner=false;
  Enable:boolean = false;
  constructor(private _TransactionService: TransactionService) { 
    this.selectedPPFileName = "Choose file";
  }

  ngOnInit(): void {
  }
  searchProduct(searchProductparam:SearchProductparam){
    this.showSpinner =true;
    this._TransactionService.GetCsaRateExcelDocument(searchProductparam).subscribe((d: any) => {
         this.downloadFile((d));
         this.showSpinner =false;
      });

  }

  downloadFile(data: any) {
   
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const url= window.URL.createObjectURL(blob);
    window.open(url);
 }
 changePP(event:any){
  if(event){
    if(event.target.files.length >0){
      this.selectedPPFileName = event.target.files[0].name;
    }
  }
}

uploadFile(files:any) {
  
  if (files.length === 0){
    alert('Please choose a file to upload!')
    return;
  }
     
  
  const formData = new FormData();

   let fileToUpload = <File>files[0];
   var filetype=fileToUpload.type;
    
    if(filetype!='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      alert('Please Upload .xlsx or .xls file');
      this.myfileVariable.nativeElement.value = "";
      this.selectedPPFileName = "";
      this.selectedPPFileName = "Choose file";
      return;
    }
    this.showSpinner=true;
    this.Enable=true;
    formData.append('file', fileToUpload, fileToUpload.name);
    this._TransactionService.ImportCSARateExcelDocument(formData).subscribe((event: any) => {
 
    var dataView = new DataView(event);
    var decoder = new TextDecoder('utf8');
    var decodedString = decoder.decode(dataView);
    if(decodedString=="1"){
      
     alert('uploaded successfully!!');
   }
   else{
    this.downloadFile(event);
    alert('uploaded successfully!!');
   }
   this.showSpinner=false;
   this.Enable=false;
   this.selectedPPFileName = "";
   this.selectedPPFileName = "Choose file";
   this.myfileVariable.nativeElement.value = "";
   });
    
}
}
